import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana25Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
   <rect width="1221" height="921" fill="url(#pattern0_1468_39209)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("10"))} 
      d="M595.578 385.704L515.214 336.999L495.731 419.799L595.578 449.022L605.32 407.622C605.32 395.933 598.826 388.14 595.578 385.704Z" 
      fill={getFillByLot(10, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))} 
      d="M447.031 298.034L515.219 336.999L500.607 397.881L403.195 371.093L415.372 315.081C421.216 291.703 438.913 293.976 447.031 298.034Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("9"))} 
      d="M580.967 517.212L595.578 449.023L495.731 419.8L476.249 487.988L580.967 517.212Z" 
      fill={getFillByLot(9, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("2"))} 
      d="M388.576 446.587L403.188 371.093L500.6 397.881L481.117 470.94L388.576 446.587Z" 
      fill={getFillByLot(2, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("8"))} 
      d="M566.355 585.397L580.967 517.209L476.249 487.985L459.202 556.174L566.355 585.397Z" 
      fill={getFillByLot(8, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("7"))} 
      d="M549.304 653.587L566.351 585.398L459.198 556.175L442.151 621.928L549.304 653.587Z" 
      fill={getFillByLot(7, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("6"))} 
      d="M534.701 704.727L549.313 653.586L442.16 621.927L422.678 694.986L512.784 716.904C526.421 718.852 533.078 709.598 534.701 704.727Z" 
      fill={getFillByLot(6, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("5"))} 
      d="M344.746 675.509L422.675 694.991L442.158 619.497L352.052 590.273L335.005 653.591C335.005 669.177 341.499 674.697 344.746 675.509Z" 
      fill={getFillByLot(5, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("4"))} 
      d="M369.103 517.209L352.056 590.268L442.162 619.492L461.644 543.998L369.103 517.209Z" 
      fill={getFillByLot(4, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("3"))} 
      d="M388.58 446.586L369.098 517.21L461.639 543.998L481.121 470.939L388.58 446.586Z" 
      fill={getFillByLot(3, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1468_39209" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1468_39209" transform="matrix(0.00334132 0 0 0.00442849 -6.38516 -1.37497)"/>
    </pattern>
    <image id="image0_1468_39209" width="4096" height="2304" href="/mz2.png"/>
    </defs>
  </svg>
  );
};